export default {
    api: {
        uri: "https://localhost:4912/"
    },
    asset: {
        base: "https://template.blob.core.windows.net/"
    }
}